import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default (function () {
    ScrollTrigger.create({
        start: "top top",
        end: 99999,
        toggleClass: {
            className: "desktop-navigation--scrolled",
            targets: ".desktop-navigation",
        },
    });
});
